import { FormSchema } from "../../../components/dynamicform/DynamicFormTypes";

export const abcdForm: FormSchema = {
    title: "ABCD Information",
    fields: [
        {
            name: "abcdDomains",
            type: "checkbox",
            label: "ABCD Domains",
            numColumns: 2,
            validationRules: {
                required: "Select at least one domain.",
                validate: {
                    atLeastOne: (v: string[]) => v.length > 0 || "Select at least one domain.",
                }
            },
            options: [
                { label: "Culture & Environment", value: "Culture & Environment" },
                { label: "Novel Technologies", value: "Novel Technologies" },
                { label: "Gender & Sexuality", value: "Gender & Sexuality" },
                { label: "Physical Health", value: "Physical Health" },
                { label: "Genetics", value: "Genetics" },
                { label: "Substance Use", value: "Substance Use" },
                { label: "Imaging", value: "Imaging" },
                { label: "Substudy - COVID-19 (please also select any relevant domains above)", value: "Substudy - COVID-19" },
                { label: "Linked External Data", value: "Linked External Data" },
                { label: "Substudy - Endocannabinoid (please also select any relevant domains above)", value: "Substudy - Endocannabinoid" },
                { label: "Mental Health", value: "Mental Health" },
                { label: "Substudy - Hurricane Irma (please also select any relevant domains above)", value: "Substudy - Hurricane Irma" },
                { label: "Neurocognition", value: "Neurocognition" },
                { label: "Substudy - Social Development (please also select any relevant domains above)", value: "Substudy - Social Development" },
            ]
        },
        {
            name: "abcdReleaseVersion",
            type: "radio",
            label: "Please select which release version you used for your publication?",
            defaultValue: "5.1 (DOI Link)",
            options: [
                { label: "5.1 (DOI Link)", value: "5.1 (DOI Link)" },
                { label: "6.0 (DOI Link)", value: "6.0 (DOI Link)" },
                { label: "Other: ", value: "", dynamic: true },
            ]
        }
    ]
};